import {
	SET_ORDER_ACTIONS,
	SET_ORDER_NUMBER,
	SET_ORDER_DETAILS,
	SET_SELECTED_ACTION,
	SET_PROCESSING_ORDER,
	SET_COLUMN_VISIBILITY,
	SET_SELECTED_SERVICE,
	SET_SEARCH_COUNTRY,
	SET_PRIVILEGE_COUNTRIES,
	SET_SELECTED_ARTICLE,
	CLEAR_ORDER_DETAILS
} from "../orderCorrectionService/types";
require("linq-extensions");

const emptyOrder = {
	details: [
		{
			countryCode: "",
			buCode: "",
			orderNo: "",
			createDate: "",
			clientSystem: "",
			referenceId: "",
			deliveryMethod: "",
			orderStatus: "",
			deliveryStatus: "",
			serviceDate: "",
			deliveryType: "",
			orderReferenceId: "",
			tspName: "",
			owner: "",
			action: "",
			compartment: "",
			enterpriseCode: "",
			orderNoSrc: "",
			orderType: "",
			serviceProviderId: "",
			connectedArticles: [],
			isEmptyLine: true
		}
	]
};

const INITIAL_STATE = {
	orderNumber: "",
	orderActions: [],
	selectedAction: { value: "", isDummy: true },
	processingOrder: { isProcessingOrder: false, message: "" },
	selectedSearchCountry: { code: "", name: "", isDummy: true },
	searchCountries: [],
	orderDetails: emptyOrder.details,

	articleColumnConfigurations: {
		selection: { id: "selection", shouldDisplay: true, title: "" },
		itemId: { id: "itemId", shouldDisplay: true, title: "Article No" },
		name: { id: "name", shouldDisplay: true, title: "Article name" },
		quantity: { id: "quantity", shouldDisplay: true, title: "Quantity" },
		salesPrice: { id: "salesPrice", shouldDisplay: true, title: "Price" },
		totalPrice: { id: "totalPrice", shouldDisplay: true, title: "Total price" }
	},

	columnConfigurations: {
		orderInfo: {
			orderNo: { id: "orderNo", shouldDisplay: true, title: "Order Number" },
			orderType: { id: "orderType", shouldDisplay: true, title: "Order type" },
			countryCode: {
				id: "countryCode",
				shouldDisplay: true,
				title: "Country"
			},
			buCode: { id: "buCode", shouldDisplay: true, title: "Store" },
			createDate: { id: "createDate", shouldDisplay: true, title: "Creation date" },
			orderStatus: {
				id: "orderStatus",
				shouldDisplay: true,
				title: "Order status"
			},
			clientSystem: {
				id: "clientSystem",
				shouldDisplay: true,
				title: "Client system"
			}
		},

		deliveryAndServicesInfo: {
			selection: { id: "selection", shouldDisplay: true, title: "" },
			referenceId: {
				id: "referenceId",
				shouldDisplay: true,
				title: "Reference Id"
			},
			deliveryType: {
				id: "deliveryType",
				shouldDisplay: true,
				title: "Service type"
			},
			serviceName: {
				id: "serviceName",
				shouldDisplay: true,
				title: "Service name"
			},
			serviceDate: {
				id: "serviceDate",
				shouldDisplay: true,
				title: "Service date"
			},
			serviceProviderId: { id: "serviceProviderId", shouldDisplay: true, title: "Service provider id" },
			tspName: { id: "tspName", shouldDisplay: true, title: "Service provider" },
			deliveryStatus: {
				id: "deliveryStatus",
				shouldDisplay: true,
				title: "Delivery status"
			}
		}
	}
};

export default function orderCorrectionReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case SET_ORDER_ACTIONS:
			return { ...state, orderActions: [...action.payload] };

		case SET_ORDER_NUMBER:
			return { ...state, orderNumber: action.payload };

		case SET_ORDER_DETAILS:
			return { ...state, orderDetails: [...action.payload] };

		case SET_SELECTED_ACTION:
			// console.log(action);
			return {
				...state,
				selectedAction: action.payload
			};
		case SET_SEARCH_COUNTRY:
			return {
				...state,
				selectedSearchCountry: action.payload
			};

		case SET_PRIVILEGE_COUNTRIES:
			return {
				...state,
				searchCountries: action.payload
			};

		case SET_PROCESSING_ORDER:
			return { ...state, processingOrder: action.payload };
		case SET_COLUMN_VISIBILITY:
			let columnDetail = {};
			if (action.payload.column in state.columnConfigurations.orderInfo) {
				columnDetail = state.columnConfigurations.orderInfo[action.payload.column];
				columnDetail = { ...columnDetail, shouldDisplay: action.payload.value };

				let orderInfo = { ...state.columnConfigurations.orderInfo, [action.payload.column]: columnDetail };

				return {
					...state,
					columnConfigurations: {
						...state.columnConfigurations,
						orderInfo: { ...orderInfo }
					}
				};
			} else {
				columnDetail = state.columnConfigurations.deliveryAndServicesInfo[action.payload.column];
				columnDetail = { ...columnDetail, shouldDisplay: action.payload.value };

				let deliveryAndServicesInfo = { ...state.columnConfigurations.deliveryAndServicesInfo, [action.payload.column]: columnDetail };

				return {
					...state,
					columnConfigurations: {
						...state.columnConfigurations,
						deliveryAndServicesInfo: { ...deliveryAndServicesInfo }
					}
				};
			}

		case SET_SELECTED_SERVICE: {
			let details = state.orderDetails.select(detail => {
				let currentArticles = detail.connectedArticles.select(article => (article = { ...article, isSelected: false }));
				if (detail.rowId === action.payload.rowId) {
					return {
						...detail,
						isSelected: action.payload.value,
						connectedArticles: currentArticles.toArray()
					};
				} else {
					return {
						...detail,
						isSelected: false,
						connectedArticles: currentArticles.toArray()
					};
				}
			});

			return { ...state, orderDetails: [...details] };
		}

		case CLEAR_ORDER_DETAILS: {
			return { ...state, orderDetails: [...emptyOrder.details] };
		}

		case SET_SELECTED_ARTICLE: {
			try {
				if (state.orderDetails.where(detail => detail.connectedArticles.any(article => article.externalRefId === action.payload.rowId)).length > 1) {
					console.log("One article can not be connected to more then 1 delivery!!");
				}
				let details = state.orderDetails.select(detail => {
					if (!detail.connectedArticles.any(article => article.externalRefId === action.payload.rowId)) {
						//article does not belong to this delivery..
						return detail;
					}
					return {
						...detail,
						// connectedArticles: detail.connectedArticles.select(article => (article.externalRefId === action.payload.rowId ? { ...article, isSelected: action.payload.value } : article)).toArray()
						connectedArticles: detail.connectedArticles
							.select(article => {
								if (article.externalRefId === action.payload.rowId) {
									return { ...article, isSelected: action.payload.value };
								} else {
									return { ...article };
								}
							})
							.toArray()
					};
				});

				return { ...state, orderDetails: [...details] };
			} catch (err) {
				console.log(err);
				throw err;
			}
		}

		default:
			return state;
	}
}
